module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1299.e4f17e52.png";